import { render, staticRenderFns } from "./ToastVip.vue?vue&type=template&id=40cdf82e&scoped=true"
import script from "./ToastVip.vue?vue&type=script&lang=js"
export * from "./ToastVip.vue?vue&type=script&lang=js"
import style0 from "./ToastVip.vue?vue&type=style&index=0&id=40cdf82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cdf82e",
  null
  
)

export default component.exports